// extracted by mini-css-extract-plugin
export default {"loadingbg":"Loading_loadingbg__6ZUhO","loading":"Loading_loading__BKmIR"};